import withAEM from '../../hoc/withAEM'
import RuleBuilderConditional from '../shared/RuleBuilderConditional'

export default withAEM(RuleBuilderConditional, {
  compName: 'RuleBuilderConditional',
  showErrorBanner: true
})
